/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/

import { getInitials } from "src/utils/ui.utils";
import { Avatar } from "antd";

interface BaseInfoProps {
  avatarSrc?: string,
  title?: string,
  subtitle?: string,
  excerpt?: string,
  showAvatar?: boolean,
};

const BaseInfo = ({
  avatarSrc,
  title,
  subtitle,
  excerpt,
  showAvatar = true,
} : BaseInfoProps) => {
  return (
    <>
      {showAvatar && (
        <div className="app-avatar">
          {!avatarSrc ? (
            <>{getInitials(title || '')}</>
          ) : (
            <>
              <Avatar src={avatarSrc} size={60}>{getInitials(title || '')}</Avatar>
            </>
          )}  
        </div>
      )}
      <div className="app-info__content">
        {title && (
          <p className="app-info__title">{title}</p>
        )}
        {subtitle && (
          <p className="app-info__subtitle">{subtitle}</p>
        )}
        {excerpt && (
          <p className="app-info__excerpt">{excerpt}</p>
        )}
      </div>
    </>
  );
};

export default BaseInfo;
